import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Logo3D } from '../components/Logo3D';
import { User, Users, Sparkles } from 'lucide-react';
export function RoleSelection() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 flex items-center justify-center p-4 relative overflow-hidden" data-id="element-1364">
      {/* Premium Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-1365">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl" data-id="element-1366"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-secondary-500/10 rounded-full blur-3xl" data-id="element-1367"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-accent-500/5 rounded-full blur-3xl" data-id="element-1368"></div>
      </div>

      <div className="w-full max-w-5xl relative z-10 animate-fade-in" data-id="element-1369">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-1370">
          <div className="flex justify-center mb-6" data-id="element-1371">
            <Logo3D size="xl" animated={true} data-id="element-1372" />
          </div>
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 bg-clip-text text-transparent" data-id="element-1373">
            Welcome to Influencer Hub
          </h1>
          <p className="text-xl text-slate-600 font-medium max-w-2xl mx-auto" data-id="element-1374">
            Premium influencer campaign management platform. Choose your role to
            get started.
          </p>
          
        </div>

        {/* Role Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1375">
          {/* Creator Card */}
          <Card variant="premium" className="group hover:scale-105 transition-all duration-300 cursor-pointer overflow-hidden" data-id="element-1376">
            <div className="absolute inset-0 bg-gradient-to-br from-primary-500/5 to-secondary-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1377"></div>
            <CardContent className="p-8 relative" data-id="element-1378">
              <div className="flex justify-center mb-6" data-id="element-1379">
                <div className="h-20 w-20 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-primary-500/30 group-hover:shadow-xl group-hover:shadow-primary-500/40 transition-all duration-300" data-id="element-1380">
                  <User className="h-10 w-10" data-id="element-1381" />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-center mb-3 text-slate-900" data-id="element-1382">
                I'm a Creator
              </h2>
              <p className="text-center text-slate-600 mb-6 leading-relaxed" data-id="element-1383">
                Manage your brand partnerships, track deliverables, and grow
                your influence with powerful analytics.
              </p>
              <ul className="space-y-3 mb-8" data-id="element-1384">
                <li className="flex items-start space-x-3" data-id="element-1385">
                  <svg className="h-5 w-5 text-primary-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-1386">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1387" />
                  </svg>
                  <span className="text-sm text-slate-700 font-medium" data-id="element-1388">
                    Campaign & deliverable tracking
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-1389">
                  <svg className="h-5 w-5 text-primary-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-1390">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1391" />
                  </svg>
                  <span className="text-sm text-slate-700 font-medium" data-id="element-1392">
                    Performance analytics dashboard
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-1393">
                  <svg className="h-5 w-5 text-primary-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-1394">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1395" />
                  </svg>
                  <span className="text-sm text-slate-700 font-medium" data-id="element-1396">
                    Brand partnership management
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-1397">
                  <svg className="h-5 w-5 text-primary-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-1398">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1399" />
                  </svg>
                  <span className="text-sm text-slate-700 font-medium" data-id="element-1400">
                    Earnings & payment tracking
                  </span>
                </li>
              </ul>
              <Button variant="premium" className="w-full h-12 text-base font-semibold" onClick={() => navigate('/creator')} data-id="element-1401">
                <Sparkles className="h-5 w-5 mr-2" data-id="element-1402" />
                Continue as Creator
              </Button>
            </CardContent>
          </Card>

          {/* Manager Card */}
          <Card variant="premium" className="group hover:scale-105 transition-all duration-300 cursor-pointer overflow-hidden" data-id="element-1403">
            <div className="absolute inset-0 bg-gradient-to-br from-secondary-500/5 to-accent-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1404"></div>
            <CardContent className="p-8 relative" data-id="element-1405">
              <div className="flex justify-center mb-6" data-id="element-1406">
                <div className="h-20 w-20 bg-gradient-to-br from-secondary-500 to-secondary-600 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-secondary-500/30 group-hover:shadow-xl group-hover:shadow-secondary-500/40 transition-all duration-300" data-id="element-1407">
                  <Users className="h-10 w-10" data-id="element-1408" />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-center mb-3 text-slate-900" data-id="element-1409">
                I'm a Manager
              </h2>
              <p className="text-center text-slate-600 mb-6 leading-relaxed" data-id="element-1410">
                Orchestrate campaigns across multiple creators, manage brands,
                and deliver exceptional results at scale.
              </p>
              <ul className="space-y-3 mb-8" data-id="element-1411">
                <li className="flex items-start space-x-3" data-id="element-1412">
                  <svg className="h-5 w-5 text-secondary-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-1413">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1414" />
                  </svg>
                  <span className="text-sm text-slate-700 font-medium" data-id="element-1415">
                    Multi-creator portfolio management
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-1416">
                  <svg className="h-5 w-5 text-secondary-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-1417">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1418" />
                  </svg>
                  <span className="text-sm text-slate-700 font-medium" data-id="element-1419">
                    Campaign & task orchestration
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-1420">
                  <svg className="h-5 w-5 text-secondary-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-1421">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1422" />
                  </svg>
                  <span className="text-sm text-slate-700 font-medium" data-id="element-1423">
                    Brand relationship management
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-1424">
                  <svg className="h-5 w-5 text-secondary-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" data-id="element-1425">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1426" />
                  </svg>
                  <span className="text-sm text-slate-700 font-medium" data-id="element-1427">
                    Advanced reporting & analytics
                  </span>
                </li>
              </ul>
              <Button variant="premium" className="w-full h-12 text-base font-semibold" onClick={() => navigate('/manager')} data-id="element-1428">
                <Sparkles className="h-5 w-5 mr-2" data-id="element-1429" />
                Continue as Manager
              </Button>
            </CardContent>
          </Card>
        </div>

        {/* Footer */}
        <div className="text-center mt-12" data-id="element-1430">
          <p className="text-sm text-slate-600 mb-4" data-id="element-1431">
            Already have an account?{' '}
            <button onClick={() => navigate('/login')} className="font-semibold text-primary-600 hover:text-primary-700 transition-colors" data-id="element-1432">
              Sign in here
            </button>
          </p>
          <div className="flex items-center justify-center space-x-8 text-xs text-slate-500" data-id="element-1433">
            <a href="#" className="hover:text-slate-700 transition-colors font-medium" data-id="element-1434">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-700 transition-colors font-medium" data-id="element-1435">
              Terms of Service
            </a>
            <a href="#" className="hover:text-slate-700 transition-colors font-medium" data-id="element-1436">
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>;
}